import React from 'react';
import { TbArrowDown } from 'react-icons/tb';
import { useTranslation } from 'react-i18next';
import Button from '../Form/Button';

interface NotifyCartViewProps {
    show: boolean;
    onClickConfirm: CallableFunction;
}

const NotifyCartView = ({
    show,
    onClickConfirm = () => {},
}: NotifyCartViewProps) => {

    const { t } = useTranslation();
    if (!show) return null;

    return (
        <div className='fixed inset-0 bottom-14 p-6 z-30 zoomInIcon grid items-center gap-2 cursor-pointer bg-gray-800/85 backdrop-blur-sm text-white'>
            <div className="absolute flex flex-col items-center justify-center bottom-0 left-1/2 transform -translate-x-1/2 w-1/2">
                <div className='mb-8 grid gap-4'>
                    <div className='w-full text-center text-xl font-extrabold leading-none'>{t('store_counter.notify_cart_view_title')}</div>

                    <div className='w-full flex justify-center items-center text-lg'>
                        <Button outline onClick={() => onClickConfirm()} className="w-auto ring-2 ring-white text-white">{t('store_counter.notify_cart_view_button_label')}</Button>
                    </div>
                </div>

                <TbArrowDown size={100} className='animate-bounce' />
            </div>
        </div>
    )
}

export default NotifyCartView;